import { useState, useEffect } from 'react';
import { apiClient } from '../api/ApiClient'; // Adjust the import according to your project structure

const useFastPhotos = () => {
  const [fastPhotos, setFastPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const apiEndpoint = `/rest/photos/15926/0/4/f?cb=${new Date().getTime()}`;

    const fetchFastPhotos = async () => {
      setLoading(true);
      try {
        let response = await apiClient.get(apiEndpoint);
        if (response.status === 200) {
          setFastPhotos(response.data);
        } else {
          console.error('HTTP error: ', response.status);
          setError('Failed to fetch fast photos');
        }
      } catch (error) {
        console.error('Fetch error: ', error);
        setError('Failed to fetch fast photos');
      } finally {
        setLoading(false);
      }
    };

    fetchFastPhotos();
  }, []);

  return { fastPhotos, loading, error };
};

export default useFastPhotos;
